import React from 'react';
import { CSSObject } from '@emotion/react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { Typography } from '@cvent/carina/components/Typography';

type CustomTextProps = {
  testID: string;
  as: string;
  text: React.ReactNode;
  typeStyle?: CSSObject;
};

export const CustomText = ({ testID, as, typeStyle = {}, text }: CustomTextProps): JSX.Element => {
  return (
    <Typography {...injectTestId(testID)} as={as} css={typeStyle}>
      {text}
    </Typography>
  );
};
